import { useState } from "react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { PrimaryButton } from "@normasteaching/norma-ui";
import { StripeOrderDTO } from "../../../Stripe/StripeOrderDTO.ts";
import { Currency } from "../../../HeyLight/useHeyLightProductById.ts";

function mapCurrencyToSymbol(currency: Currency): string {
  switch (currency) {
    case Currency.Eur:
      return "€";
    default:
      return currency;
  }
}

export function CardInstallmentsUpdatePaymentForm({
  orderInfo,
}: {
  orderInfo: {
    normasTeachingItemName: string;
    order: StripeOrderDTO;
    returnUrl?: string;
  };
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [confirming, setConfirming] = useState(false);

  console.log("OrderInfo", orderInfo);
  const onConfirmPayment = async () => {
    if (!stripe || !elements) {
      // handleError(
      //   "Errore nel caricamento di Stripe. Riprova tra qualche secondo.",
      // );
      return;
    }

    setConfirming(true);
    try {
      const { error } = await stripe.confirmSetup({
        elements,
        confirmParams: { return_url: orderInfo.returnUrl },
        redirect: "if_required",
      });

      if (error) {
        // handleError(error.message || "Pagamento non riuscito.");
      } else {
        // onSuccess();
      }
    } catch (err) {
      // handleError("Errore durante la conferma del pagamento.");
    } finally {
      setConfirming(false);
    }
  };

  // if (!orderInfo.order.numberOfInstallments) {
  //   // handleError("Numero di rate non specificato.");
  //   return;
  // }

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white">
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Completa il pagamento
          </h2>
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="text-lg font-medium text-gray-900">
              {orderInfo.normasTeachingItemName}
            </div>
            <div className="text-gray-600">
              Totale: {(orderInfo.order.productPrice.amount / 100).toFixed(2)}{" "}
              {mapCurrencyToSymbol(
                orderInfo.order.productPrice.currency as Currency,
              )}
            </div>
            <div className="text-gray-600">
              In {orderInfo.order.numberOfInstallments} rate da{" "}
              {(
                orderInfo.order.productPrice.amount /
                orderInfo.order.numberOfInstallments! /
                100
              ).toFixed(2)}{" "}
              {mapCurrencyToSymbol(
                orderInfo.order.productPrice.currency as Currency,
              )}
            </div>
          </div>
        </div>

        <div className="bg-blue-50 p-4 rounded-lg">
          <h3 className="font-medium text-gray-900 mb-2">Dati acquirente</h3>
          <p className="text-sm text-gray-700">
            {orderInfo.order.customerInformation.firstName}{" "}
            {orderInfo.order.customerInformation.lastName}
          </p>
          <p className="text-sm text-gray-700">
            {orderInfo.order.customerInformation.email}
          </p>
        </div>

        <div className="w-full">
          <label className="block text-md font-bold text-gray-900 mb-3">
            Dati della carta
          </label>
          <div className="w-full [&_.__PrivateStripeElement]:max-w-full">
            <PaymentElement
              options={{
                layout: {
                  type: "accordion",
                  defaultCollapsed: false,
                  radios: true,
                  spacedAccordionItems: false,
                },
                wallets: {
                  applePay: "auto",
                  googlePay: "auto",
                },
              }}
            />
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-6">
          <PrimaryButton
            label={
              confirming ? "Elaborazione in corso..." : "Completa il pagamento"
            }
            onClick={onConfirmPayment}
            disabled={!stripe || !elements || confirming}
            loading={confirming}
          />
        </div>
      </div>
    </div>
  );
}
